import React from "react";
import icon from './icon.svg';
import './filter.css'

const HomeButton = () => {
    return (
    <>
        <a href="/">
            <img src={icon} alt="" style={{ height: 53, width: 36 }} className="svg ml-2" />
        </a>
    </>
    )
}

export default HomeButton;